/**
 *  Counter script file
**/

export default {
  name: 'Counter',
  mixins: [],
  components: {},
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    text: {
      type: String,
      required: true
    },
    velocity: {
      type: Number,
      required: false
    },
    color: {
      type: String,
      default: '#16969d',
      required: false
    },
    symbol: {
      type: String,
      required: false
    },
    format: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {}
  },
  computed: {
  },
  methods: {
  }
}
